module.exports = __webpack_public_path__ + "static/media/10.770a6f5d.jpg";